<template>
  <div class="page-content" :style="defaultHeight">
    <div class="startTitle">修改密码</div>
    <el-row class="pad80">
      <el-col :span="8" :offset="8">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="原密码" prop="oldPass">
            <el-input v-model="ruleForm.oldPass" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpass">
            <el-input v-model="ruleForm.newpass" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPass">
            <el-input v-model="ruleForm.confirmPass" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="submitForm('ruleForm')" class="dmh-btn sub-btn">确定</el-button>
            <el-button @click="resetForm('ruleForm')" class="dmh-btn cls-btn">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { updatePwd } from '@/api/user'
export default {
  name: "changePass",
  data () {
    return {
      defaultHeight: {
        height: ""
      },
      ruleForm: {
        oldPass: "",
        newpass: '',
        confirmPass: '',
      },
      rules: {
        oldPass: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newpass: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, message: '请再确认新密码', trigger: 'blur' }
        ]
      }
    }
  },
  components: {},
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 106 + "px";
    },
    submitAjax () {
      var data = {
        "oldPassword": this.ruleForm.oldPass,
        "newPassword": this.ruleForm.newpass
      };
      updatePwd(data).then(res => {
        if (parseFloat(res.data.code) === 200) {
          this.message("修改成功", 'success');
          this.$refs["ruleForm"].resetFields();
        } else {
          this.message(res.data.msg);
        }
      });
    },
    submitForm (formName) {
      var ths = this;
      if (this.ruleForm.newpass !== this.ruleForm.confirmPass) {
        this.message("你输入新密码与确认密码不一致！请重新输入！")
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ths.submitAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  },
}
</script>

<style scoped>
.pad80 {
  padding-top: 80px;
}
.sub-btn {
  background: #14c86c;
  border-color: #14c86c;
}
.cls-btn:hover,
.sub-btn:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/changePass.vue